import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { withSetPropAction } from "mobx-stores/_extension/with-set-props";
import { Base } from "../base";
import { Customer } from "../customers/customer";
import { DeliveryAddress } from "../customers/delivery-address";
import {
  IAddQuotationItem,
  IUpdateQuotationItem,
  QuotationItem,
} from "./quotation-item";

export const Quotation = types
  .compose(
    Base,
    types.model({
      orderNumber: types.maybeNull(types.number),
      date: types.maybeNull(types.string),
      number: types.maybeNull(types.string),
      customerId: types.maybeNull(types.string),
      customer: types.maybeNull(Customer),
      receiverInfo: types.maybeNull(types.string),
      deliveryAddressId: types.maybeNull(types.string),
      deliveryAddress: types.maybeNull(DeliveryAddress),
      note: types.maybeNull(types.string),
      items: types.optional(types.array(QuotationItem), []),
    })
  )
  .actions(withSetPropAction);
export interface IQuotation extends Instance<typeof Quotation> {}
export interface IQuotationProperties extends SnapshotIn<typeof Quotation> {}
export interface IAddQuotation
  extends Pick<
    IQuotationProperties,
    | "date"
    | "number"
    | "customerId"
    | "receiverInfo"
    | "note"
    | "deliveryAddressId"
  > {
  items: IAddQuotationItem[];
}

export interface IUpdateQuotation
  extends Pick<
    IQuotationProperties,
    | "id"
    | "date"
    | "number"
    | "customerId"
    | "receiverInfo"
    | "note"
    | "deliveryAddressId"
  > {
  items: IUpdateQuotationItem[];
}
